const BUMI_FILTER = [
  { text: 'Bumiputera', value: 'true' },
  { text: 'Non-Bumiputera', value: 'false' },
];
export default BUMI_FILTER;



// WEBPACK FOOTER //
// ./src/constants/bumiFilter.js